import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/site/Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Fechar menu ao clicar fora dele (mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('.main-nav') && !event.target.closest('.mobile-menu-toggle')) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [menuOpen]);

  // Prevenir scroll quando menu mobile estiver aberto
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/" onClick={closeMenu}>
              <img src="/images/site/logo192.svg" alt="Liv_IAm Logo" />
            </Link>
          </div>

          {/* Menu Desktop + Mobile */}
          <nav className={`main-nav ${menuOpen ? 'open' : ''}`}>
            {/* Overlay para mobile */}
            {menuOpen && <div className="nav-overlay" onClick={closeMenu}></div>}
            
            <div className="nav-container">
              {/* Header do menu mobile */}
              <div className="mobile-nav-header">
                <div className="mobile-nav-logo">
                  <img src="/images/site/logo192.svg" alt="Liv_IAm Logo" />
                </div>
                <button className="mobile-nav-close" onClick={closeMenu}>
                  <i className="fas fa-times"></i>
                </button>
              </div>

              <ul className="nav-list">
                <li className="nav-item">
                  <Link to="/" className="nav-link" onClick={closeMenu}>
                    <i className="fas fa-home nav-icon"></i>
                    <span>Início</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/sobre" className="nav-link" onClick={closeMenu}>
                    <i className="fas fa-info-circle nav-icon"></i>
                    <span>Sobre</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/valores" className="nav-link" onClick={closeMenu}>
                    <i className="fas fa-star nav-icon"></i>
                    <span>Valores</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/blog" className="nav-link" onClick={closeMenu}>
                    <i className="fas fa-blog nav-icon"></i>
                    <span>Blog</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/depoimentos" className="nav-link" onClick={closeMenu}>
                    <i className="fas fa-comments nav-icon"></i>
                    <span>Depoimentos</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/contato" className="nav-link" onClick={closeMenu}>
                    <i className="fas fa-envelope nav-icon"></i>
                    <span>Contato</span>
                  </Link>
                </li>
                
                {/* CTAs no menu mobile */}
                <li className="nav-item mobile-cta-items">
                  <Link to="/client/login" className="btn btn-primary mobile-cta" onClick={closeMenu}>
                    <i className="fas fa-rocket"></i>
                    Iniciar Agora
                  </Link>
                  <Link to="/admin/login" className="btn btn-outline mobile-cta" onClick={closeMenu}>
                    <i className="fas fa-user-shield"></i>
                    Administrativo
                  </Link>
                </li>
              </ul>
            </div>
          </nav>

          {/* CTAs Desktop */}
          <div className="header-cta desktop-only">
            <Link to="/admin/login" className="btn btn-outline btn-sm">
              <i className="fas fa-user-shield"></i>
              <span className="btn-text">Admin</span>
            </Link>
            <Link to="/client/login" className="btn btn-primary">
              <i className="fas fa-rocket"></i>
              <span className="btn-text">Iniciar Agora</span>
            </Link>
          </div>

          {/* Botão do menu mobile */}
          <button 
            className="mobile-menu-toggle" 
            onClick={toggleMenu} 
            aria-label="Menu"
            aria-expanded={menuOpen}
          >
            <span className={`hamburger ${menuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;